import React from 'react';
import { Modal, Button, Card, Badge } from 'react-bootstrap';

const QuestionPreview = ({ show, onHide, section }) => {
  if (!section) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Preview: {section.sectionTitle}
          <Badge bg="secondary" className="ms-2">
            Form {section.formType}
          </Badge>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card>
          <Card.Header>
            <h5 className="mb-0">{section.sectionTitle}</h5>
            <small className="text-muted">
              {section.questions.length} questions • Order: {section.sectionOrder}
            </small>
          </Card.Header>
          <Card.Body>
            <div className="questions-preview">
              {section.questions
                .sort((a, b) => a.order - b.order)
                .map((question, index) => (
                  <div key={index} className="question-preview-item mb-3 p-3 border rounded">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1">
                        <strong className="text-primary">Q{index + 1}:</strong>
                        <span className="ms-2">{question.text}</span>
                        {question.helpText && (
                          <div className="text-muted small mt-1">
                            <em>Help: {question.helpText}</em>
                          </div>
                        )}
                      </div>
                      <div>
                        {question.isRequired && (
                          <Badge bg="warning" className="ms-2">
                            Required
                          </Badge>
                        )}
                      </div>
                    </div>
                    
                    {/* Preview of answer options */}
                    <div className="mt-2">
                      <div className="btn-group" role="group">
                        <button type="button" className="btn btn-outline-success btn-sm">
                          YES
                        </button>
                        <button type="button" className="btn btn-outline-danger btn-sm">
                          NO
                        </button>
                        <button type="button" className="btn btn-outline-warning btn-sm">
                          NA
                        </button>
                        <button type="button" className="btn btn-outline-info btn-sm">
                          COMMENT
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QuestionPreview;